export const States = [
    
    "Andhra Pradesh",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Delhi",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
   
   
]

export const specializationCourses = [
    "Computer Science",
    
    "Artifical Intelligence",
    "Cloud Computing",
    "Data Science",
    "Cyber Security",
];

export const InstituteType = [
    "Government",
    "Private",
    "Public"
]